import { render, staticRenderFns } from "./AppValor.vue?vue&type=template&id=b71cd678&scoped=true&"
import script from "./AppValor.vue?vue&type=script&lang=js&"
export * from "./AppValor.vue?vue&type=script&lang=js&"
import style0 from "./AppValor.vue?vue&type=style&index=0&id=b71cd678&lang=scss&scoped=true&"
import style1 from "./AppValor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71cd678",
  null
  
)

export default component.exports